interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Centered card layout for unauthenticated screens (login, change password).
 * Matches prototype `Class Scheduler.dc.html:30-47`.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-page flex items-center justify-center p-6">
      <div className="w-full max-w-[380px] animate-fade-in">{children}</div>
    </div>
  );
}
